import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { FileKeyFacilitationState } from '@/types/fileKey/FileKeyFacilitation';

const initialState: FileKeyFacilitationState = {
  status: 'idle',
  processedCount: 0,
  totalCount: 0,
  errors: [],
};

const fileKeyFacilitationSlice = createSlice({
  name: 'fileKeyFacilitation',
  initialState,
  reducers: {
    startFacilitation(state, action: PayloadAction<{ totalCount: number }>) {
      state.status = 'running';
      state.totalCount = action.payload.totalCount;
      state.processedCount = 0;
      state.errors = [];
    },
    fileKeyProcessed(state) {
      state.processedCount += 1;
    },
    fileKeyFailed(state, action: PayloadAction<string>) {
      state.errors.push(action.payload);
    },
    facilitationComplete(state) {
      state.status = state.errors.length > 0 ? 'error' : 'complete';
    },
  },
});

export const {
  startFacilitation,
  fileKeyProcessed,
  fileKeyFailed,
  facilitationComplete,
} = fileKeyFacilitationSlice.actions;

export default fileKeyFacilitationSlice.reducer;
